/* global axios */
import ApiClient from './ApiClient';

class ConversationNotesAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  get(conversationId, params = {}) {
    return axios.get(`${this.url}/${conversationId}/messages`, {
      params: {
        filter_only_private: true,
        ...params,
      },
    });
  }
}

export default new ConversationNotesAPI();
